import { Box, Typography } from '@mui/material';
import { formatCurrency } from '../utils/directDebitIcbcUtils';

const SummaryItem = ({ label, value }) => (
  <Box sx={{ minWidth: 160 }}>
    <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 700 }}>
      {label}
    </Typography>
    <Typography variant="body1" sx={{ fontWeight: 700 }}>
      {value}
    </Typography>
  </Box>
);

const DirectDebitIcbcSummary = ({ summary, period }) => {
  if (!summary) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 3,
        alignItems: 'center',
        px: 3,
        py: 2,
        backgroundColor: 'background.paper',
        borderBottom: '1px solid #d7d7d7',
      }}
    >
      <SummaryItem label="Registros" value={summary.total_records || 0} />
      <SummaryItem label="Total" value={formatCurrency(summary.total_amount)} />
      <SummaryItem label="Excluidos" value={summary.excluded_count || 0} />
      <SummaryItem label="Referencia" value={period?.reference || '-'} />
      <SummaryItem label="Vencimiento" value={period?.due_date || '-'} />
    </Box>
  );
};

export default DirectDebitIcbcSummary;
